
import { takeEvery } from "redux-saga/effects";
import { GET_ALL_PRODUCT_TESTIMONIAL, GET_PRODUCT_TESTIMOINALS_BY_CATEGORY } from "../actionTypes";
import apiCall from './../../services/api';
import { ENDPOINT } from "src/config/endpoints";


function* getAllTestimonials(actions) {
    try {
      const response = yield apiCall({
        method: 'GET',
        url: ENDPOINT.PRODUCT_TESTIMONIAL.allPTestimonial(actions?.data?.dataToSend)
      });
      if (response && response.data.status) {
        actions.data?.callback(JSON.parse(response?.data?.data));
      }
    } catch (err) {
      console.log(err);
    }
}

function* getCategoryPTestimonials(actions) {
    try {
      const response = yield apiCall({
        method: 'GET',
        url: ENDPOINT.PRODUCT_TESTIMONIAL.allCategoryPTestimonial(actions?.data?.dataToSend)
      });
      if (response && response.data.status) {
        actions.data?.callback(JSON.parse(response?.data?.data));
      }
    } catch (err) {
      console.log(err);
    }
}

export default function* root() {
  yield takeEvery(GET_ALL_PRODUCT_TESTIMONIAL, getAllTestimonials);
  yield takeEvery(GET_PRODUCT_TESTIMOINALS_BY_CATEGORY, getCategoryPTestimonials);
}
